import React from 'react';
import { Input, Button, ButtonHierarchies, InputSizes } from '@clockout-dev/design-elements';
import { DownOutlined, LockOutlined, UpOutlined } from '@ant-design/icons';
import SectionCard from '../../common/sectionCard/SectionCard';
import styles from '../styles/account.module.scss';

/**
 * Pure presentational card for the "Password" section. Surfaces a toggle the
 * user clicks to reveal the three password inputs (current / new / confirm).
 * The orchestrator owns the `open` flag and clears the inputs on close, so
 * this component stays stateless.
 */
function PasswordCard({
    open,
    currentPassword,
    newPassword,
    confirmPassword,
    hasError,
    onToggle,
    onCurrentPasswordChange,
    onNewPasswordChange,
    onConfirmPasswordChange,
}) {
    const errorStatus = hasError ? 'error' : '';

    return (
        <SectionCard
            icon={<LockOutlined />}
            title="Password"
            action={
                <div className={styles.passwordToggleRow}>
                    <Button
                        hierarchy={ButtonHierarchies.LINK_COLOR}
                        icon={open ? <UpOutlined /> : <DownOutlined />}
                        onClick={() => onToggle?.()}>
                        {open ? 'Cancel' : 'Change Password'}
                    </Button>
                </div>
            }>
            {open ? (
                <div className={styles.passwordFields}>
                    <Input.Password
                        size={InputSizes.SMALL}
                        id="currentPassword"
                        label="Current password"
                        prefix={<LockOutlined className={styles.inputIcon} />}
                        value={currentPassword || ''}
                        onChange={(e) => onCurrentPasswordChange?.(e.target.value)}
                        placeholder="Enter current password"
                        status={errorStatus}
                        autoComplete="current-password"
                    />

                    <Input.Password
                        size={InputSizes.SMALL}
                        id="newPassword"
                        label="New password"
                        prefix={<LockOutlined className={styles.inputIcon} />}
                        value={newPassword || ''}
                        onChange={(e) => onNewPasswordChange?.(e.target.value)}
                        placeholder="Enter new password"
                        status={errorStatus}
                        autoComplete="new-password"
                    />

                    <Input.Password
                        size={InputSizes.SMALL}
                        id="confirmPassword"
                        label="Confirm new password"
                        prefix={<LockOutlined className={styles.inputIcon} />}
                        value={confirmPassword || ''}
                        onChange={(e) => onConfirmPasswordChange?.(e.target.value)}
                        placeholder="Confirm new password"
                        status={errorStatus}
                        autoComplete="new-password"
                    />
                </div>
            ) : null}
        </SectionCard>
    );
}

export default PasswordCard;
